import React from 'react';
import moment from 'moment-with-locales-es6';
import { ChatBodyProps } from "../index";
import styled from 'styled-components';

moment.locale(window.navigator.language);

interface TimeDividerProps {
  date: string | Date,
  styles: ChatBodyProps
}

const TimeDividerBody = styled.div`
  margin-bottom: 0;
  /* background-color: rgba(225, 245, 254, 0.92); */
  border-radius: 7.5px;
  box-shadow: 0 1px .5px rgba(0, 0, 0, 0.13);
  padding: 5px 12px 6px;
  text-align: center;
  text-shadow: 0 1px 0 rgba(255, 255, 255, .4);
  box-sizing: border-box;
  /* color: rgba(0, 0, 0, 0.88); */
  display: inline-block;
  flex: none;
  font-size: 13px;
  line-height: 21px;
  max-width: 100% !important;
  position: relative;
`;

const TimeDividerText = styled.span`
  font-size: 100%;
  display: inline;
  vertical-align: initial;
  outline: none;
  margin: 0;
  padding: 0;
  border: 0;
`;

const TimeDividerContainer = styled.div<{styles: ChatBodyProps}>`
  ${TimeDividerBody}{
    background-color: ${props => props.styles.timeDividerBackgroundColor};
    color: ${props => props.styles.timeDividerTextColor};
  } 
  padding-left: 8%;
  padding-right: 8%;
  margin-bottom: 12px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
`;

const getReadableTime = (date: Date | string) => {
  const yesterday = moment().subtract(1, 'day').startOf('day');
  const getTodayOrYesterday = (): string => {
    return moment(date).calendar().split(' ')[0].toUpperCase();
  }

  const isSameWeek = () => {
    const today = moment(new Date());
    const msgDate = moment(date);
    if (today.diff(msgDate, 'days') > 7) {
      return false;
    }
    return msgDate.format('e') < today.format('e');
  }

  let readableTime: string;
  if (moment(date).diff(yesterday) >= 0) {
    readableTime = getTodayOrYesterday();
  } else if (isSameWeek()) {
    readableTime = moment(date).format('dddd').toUpperCase();
  } else {
    readableTime = moment(date).format('DD/MM/YYYY');
  }

  return readableTime;
}

function TimeDivider({ date, styles }: TimeDividerProps) {
  return (
    <TimeDividerContainer as="sdiv" styles={styles}>
      <TimeDividerBody as="sdiv">
        <TimeDividerText as="sdiv" dir="auto">{getReadableTime(date)}</TimeDividerText>
      </TimeDividerBody>
    </TimeDividerContainer>
  );
}

export default React.memo(TimeDivider);
